import React, {useEffect, useState} from "react";
import {
    Box,
    Button,
    CardContent, Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow, Typography
} from "@mui/material";
import PageLayout from "../components/layout/PageLayout";
import {fetchCurrencies, selectCurrencies} from "../store/currencySlice";
import {useDispatch, useSelector} from "react-redux";
import {AccountBalanceWallet, AddCircle, CreateNewFolder, CreditCard} from "@mui/icons-material";
import WalletService from "../services/WalletService";
import {useNavigate, useSearchParams} from "react-router-dom";
import {fetchBudgets, selectAllBudgets, selectBudgets} from "../store/budgetSlice";
import EditBudgetForm from "../components/form/EditBudgetForm";
import Budget from "../components/entry/Budget";
import {useTranslation} from "react-i18next";


const BudgetsPage = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const budgets = useSelector(state => selectAllBudgets(state));
    const [selectedBudget, setSelectedBudget] = useState(null);
    const [resetTrigger, setResetTrigger] = useState(Date.now());


    useEffect(() => {
        dispatch(fetchBudgets());
        dispatch(fetchCurrencies())
    }, []);

    useEffect(() => {
        let budget = null;
        const budgetIdStr = searchParams.get("budget");
        if(budgetIdStr != null) {
            if(!selectedBudget || selectedBudget.id != budgetIdStr) {
                const budgetId = Number(budgetIdStr);
                budget = budgets && budgets.find(eachBudget => eachBudget.id === budgetId);

                if(budget) {
                    setSelectedBudget(budget)
                }
            }
        } else {
            if(selectedBudget && selectedBudget.id) {
                setSelectedBudget(null);
            }
        }
    }, [budgets, searchParams]);

    const onNewBudgetClick = () => {
        clearSelectionWithUrl();
        setSelectedBudget({name: ""});
    }


    const onBudgetClick = (budget) => {
        clearSelection();
        setSelectedBudget(budget);
        navigate(`?budget=${budget.id}`)
    }

    const clearSelectionWithUrl = () => {
        navigate(`?`);
        clearSelection();
    }

    const clearSelection = () => {
        setSelectedBudget(null);
        setResetTrigger(Date.now());
    }

    return (
        <PageLayout title={t("pages.budgets.title")}>
            <CardContent sx={{minHeight: 200, maxHeight: '90%', overflowY: "auto"}}>
                {WalletService.getActive(budgets)
                    .map(
                        (budget) =>
                            <Budget key={budget.id} budget={budget} onBudgetClick={onBudgetClick}/>
                    )
                }
                <Box sx={{height: 50}}></Box>

                <Button style={{position: "absolute", bottom: 30, right: "46%", fontSize: "4rem"}}
                        onClick={onNewBudgetClick}>
                    <AddCircle fontSize="inherit"/>
                </Button>
            </CardContent>
            {selectedBudget && <EditBudgetForm budget={selectedBudget}
                                                   onCancel={clearSelectionWithUrl} resetTrigger={resetTrigger}></EditBudgetForm>}
        </PageLayout>
    );
}

export default BudgetsPage